import { useDictionary } from '@/shared/api';
import type { BanksData } from '@/shared/types';

const useBanksDictionary = () => {
  const {
    data: banksData,
    isLoading: isBanksLoading,
    error: banksError,
    isError: isBanksError,
  } = useDictionary<BanksData>({
    dictionaryName: 'banks',
  });

  return {
    banksData,
    isBanksLoading,
    banksError,
    isBanksError,
  };
};

export { useBanksDictionary };
